var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeView === "info"
    ? _c("div", { staticClass: "row", attrs: { id: "info-content" } }, [
        _c("div", { staticClass: "col-12 pt-2" }, [
          _c("p", {
            staticClass: "lead fw-bold",
            domProps: { innerHTML: _vm._s(_vm.dto.infoContent.title) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 pt-2" },
          [
            _c("p", {
              staticClass: "standard",
              domProps: { innerHTML: _vm._s(_vm.dto.infoContent.text) },
            }),
            _vm._v(" "),
            _c("AlertMessage", {
              staticClass: "ob1-alert",
              attrs: {
                title: _vm.dto.infoContent.info,
                type: "info",
                "with-alert-role": "",
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }